import { TokenDetailForm } from "components/TokenDetailForm";
import { RegisteredTokenDetail } from "models/factory/RegisteredTokenResponse";
import { ConfigResponse } from "models/staking/ConfigResponse";
import { TokenInfoResponse } from "models/token/TokenInfoResponse";

type Props = { tokenInfo?: TokenInfoResponse, config?: ConfigResponse, tokenDetail?: RegisteredTokenDetail, pool?: number }

export function TokenDetailModal({ tokenDetail, tokenInfo, config, pool }: Props) {
    return <div className="modal-content">
        <div className="modal-header">
            <h5 className="modal-title">Token Detail</h5>
            <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            ></button>
        </div>
        <div className="modal-body">
            <TokenDetailForm
                pool={pool}
                config={config}
                tokenInfo={tokenInfo}
                tokenDetail={tokenDetail} />
        </div>
    </div>
}